export default "__VITE_ASSET__BWacZIvn__"